let supportFileAPI = function() { // Is the File API supported?
  var fi = document.createElement('INPUT');
  fi.type = 'file';
  return 'files' in fi;
};

let supportAjaxUploadProgressEvents = function() { // Are progress events supported?
  // eslint-disable-next-line no-undef
  var xhr = new XMLHttpRequest();
  return !!(xhr && ('upload' in xhr) && ('onprogress' in xhr.upload));
};

let supportFormData = function() { // Is FormData supported?
  return !!window.FormData;
};

export default function() {
  return supportFileAPI() && supportAjaxUploadProgressEvents() && supportFormData();
};
